
import { Badge } from "@/components/ui/badge";

const AffiliateHeader = () => {
  return (
    <div className="text-center mb-12">
      <Badge className="mb-4 bg-primary-dark text-white px-4 py-2">
        Partner Program
      </Badge>
      <h1 className="text-4xl font-bold text-gray-900 mb-4">
        NearLab Services Affiliate Program
      </h1>
      <p className="text-xl text-gray-600 max-w-2xl mx-auto">
        Join our network of trusted partners and earn competitive commissions by referring clients to our professional testing services.
      </p>
    </div>
  );
};

export default AffiliateHeader;
